import 'Components/vm-icon/vm-icon';
import type { IconSize } from 'Components/vm-icon/vm-icon';
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import Styles from './vm-loading-spinner.scss';

/**
 * Animated loading spinner. Wraps `vm-icon` with the `loading` glyph
 * and rotates it 360° continuously.
 *
 * @attr size - Size tier passed straight through to the inner `vm-icon`.
 *              Defaults to `md`. Same enum as every other icon in the app.
 * @csspart icon - The inner `vm-icon` host (for consumers that need to
 *              override color via `::part(icon)`).
 */
@customElement('vm-loading-spinner')
export class VmLoadingSpinner extends LitElement {
    static override styles = Styles;

    @property({ type: String })
    size: IconSize = 'md';

    override render() {
        return html`<vm-icon part="icon" name="loading" size=${this.size}></vm-icon>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'vm-loading-spinner': VmLoadingSpinner;
    }
}
